// Severity classification helpers for KPI tiles and composite-card rows.
// Risk metrics escalate neutral → caution (1-9) → alert (10+); action items
// stay caution because they communicate work, not damage. Both return "none"
// at zero so empty queues fade into the background and only non-zero counts
// pull the eye.

export type Severity = "none" | "caution" | "alert";
export type ActionSeverity = "none" | "caution";

export function severityForRisk(count: number | null | undefined): Severity {
  if (!count || count < 1) return "none";
  if (count >= 10) return "alert";
  return "caution";
}

export function severityForAction(
  count: number | null | undefined
): ActionSeverity {
  return count && count >= 1 ? "caution" : "none";
}
